import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Lucide's user-star with its star swapped for Lucide's bell, scaled to the star's width:
// the Subscriber (Additional Contact) field.
export const USER_BELL_NODES: IconNode = [
  [
    'path',
    {
      key: 'user-bell-0',
      d: 'M12.281 18.246C12.137 18.404 12.1 18.632 12.186 18.828C12.273 19.024 12.466 19.15 12.68 19.15L21.32 19.15C21.534 19.15 21.728 19.024 21.814 18.828C21.901 18.633 21.864 18.405 21.72 18.247C21.001 17.506 20.24 16.719 20.24 14.29C20.24 12.501 18.789 11.05 17 11.05C15.211 11.05 13.76 12.501 13.76 14.29C13.76 16.719 12.998 17.506 12.281 18.246',
    },
  ],
  [
    'path',
    {
      key: 'user-bell-1',
      d: 'M16.065 21.31C16.258 21.644 16.614 21.85 17 21.85C17.386 21.85 17.742 21.644 17.935 21.31',
    },
  ],
  [
    'path',
    {
      key: 'user-bell-2',
      d: 'M8 15L7 15C4.791 15 3 16.791 3 19L3 21',
    },
  ],
  [
    'path',
    {
      key: 'user-bell-3',
      d: 'M10 3C12.209 3 14 4.791 14 7C14 9.209 12.209 11 10 11C7.791 11 6 9.209 6 7C6 4.791 7.791 3 10 3Z',
    },
  ],
]

export const UserBellIcon: LucideIcon = createLucideIcon(
  'user-bell',
  USER_BELL_NODES,
)
